var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd9200",
    d: "m283.59 313.41-2.95 101.42c7.09 5.7 16.07 9.1 25.8 9.1h77.33l68.6 53.63c.65.51 1.47.57 2.18.17.71-.37 1.11-1.11 1.05-1.9l-4.34-51.9h4c22.76 0 41.39-18.62 41.39-41.41V275.37c0-22.76-18.62-41.39-41.39-41.39h-46.74z",
    "data-original": "#fd9200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf00",
    d: "M350.97 91.57c76.76 76.79 76.76 201.26 0 278.05-63.61 63.58-159.9 74.49-234.74 32.74l-36.43 9.78-40.99 10.97c-.71.2-1.42 0-1.93-.51-.54-.51-.71-1.22-.54-1.93l11-40.99 8.05-30.13C-3.3 272.48 2.53 161.99 72.95 91.57c76.76-76.76 201.23-76.76 278.02 0z",
    "data-original": "#ffbf00"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.56 256.01c13.49 0 24.49-11.03 24.49-24.52S110.05 207 96.56 207s-24.52 11-24.52 24.49 11.03 24.52 24.52 24.52zM211.96 256.01c13.49 0 24.49-11.03 24.49-24.52s-11-24.49-24.49-24.49-24.49 11-24.49 24.49 11 24.52 24.49 24.52zM327.36 256.01c13.49 0 24.49-11.03 24.49-24.52s-11-24.49-24.49-24.49-24.49 11-24.49 24.49 10.99 24.52 24.49 24.52z",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/commentIcon.bb1c48041f70aa658168b8d9f0d6aa9b.svg";
export { ForwardRef as ReactComponent };